<div class="profile" *ngIf="!isLoading" [formGroup]="userForm">

  <!-- ===== Carte identité ===== -->
  <section class="pf-card pf-identity">
    <div class="pf-avatar">{{ initials }}</div>
    <div class="pf-identity-text">
      <h2 class="pf-name">{{ clientInfos.name || '—' }}</h2>
      <p class="pf-id">
        Identifiant : <span>{{ clientInfos.customerId || '—' }}</span>
      </p>
    </div>
  </section>

  <!-- ===== Informations de l'entreprise (lecture seule) ===== -->
  <section class="pf-card">
    <div class="pf-card-head">
      <div>
        <h3 class="pf-title">Informations de l'entreprise</h3>
        <p class="pf-sub">Ces informations ne sont pas modifiables. Contactez le support pour toute correction.</p>
      </div>
    </div>

    <dl class="pf-info">
      <div class="pf-info-item">
        <dt>Nom de l'entreprise</dt>
        <dd>{{ clientInfos.name || '—' }}</dd>
      </div>
      <div class="pf-info-item">
        <dt>NINEA</dt>
        <dd>{{ clientInfos.ninea || '—' }}</dd>
      </div>
      <div class="pf-info-item" *ngIf="ownerName">
        <dt>Responsable</dt>
        <dd>{{ ownerName }}</dd>
      </div>
    </dl>
  </section>

  <!-- ===== Coordonnées (modifiables) ===== -->
  <section class="pf-card">
    <div class="pf-card-head">
      <div>
        <h3 class="pf-title">Coordonnées</h3>
        <p class="pf-sub">Adresse et contact utilisés pour échanger avec vous.</p>
      </div>
      <button *ngIf="!isEditing" type="button" class="pf-btn pf-btn--outline" (click)="toggleEdit()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>
        Modifier
      </button>
    </div>

    <div class="pf-form">
      <div class="pf-field pf-field--full">
        <label for="pf-address">Adresse</label>
        <div class="pf-input-wrap">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>
          <input id="pf-address" type="text" formControlName="address" placeholder="Adresse de l'entreprise" />
        </div>
      </div>

      <div class="pf-field">
        <label for="pf-email">Email</label>
        <div class="pf-input-wrap">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m22 7-10 6L2 7"></path></svg>
          <input id="pf-email" type="email" formControlName="email" placeholder="nom@exemple.com" />
        </div>
      </div>

      <div class="pf-field">
        <label for="pf-phone">Téléphone</label>
        <div class="pf-input-wrap">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
          <input id="pf-phone" type="tel" formControlName="phone" placeholder="77 123 45 67" />
        </div>
      </div>
    </div>

    <div class="pf-actions" *ngIf="isEditing">
      <button type="button" class="pf-btn pf-btn--outline" (click)="cancelEdit()">Annuler</button>
      <button type="button" class="pf-btn pf-btn--primary" (click)="saveChanges()">Enregistrer</button>
    </div>
  </section>
</div>

<!-- Chargement -->
<div class="pf-loading" *ngIf="isLoading">
  <span class="pf-spinner"></span>
  Chargement du profil…
</div>